import axios from 'axios';
import { Base64 } from 'js-base64';

/**
 * 获取是否需要底部模板推荐
 * @returns boolean
 */
export const getIsNeedRecommend = async () => {
    try {
        const result = await axios({
            method: 'GET',
            url: '/v2/mall/profile/recommend/switch',
        });
        const { data } = result;
        if (data?.retcode !== 0) {
            throw new Error('getNeedRecommend data', data);
        }
        return !!data?.result?.needRecommend;
    } catch (err) {
        console.error('getTemplateInfos data', err);
    }
};

/**
 * 获取模板数据
 * @returns string
 */
export const getTemplateInfos = async (id, isCustom = false) => {
    try {
        const result = await axios({
            method: 'POST',
            url: '/v2/mall/doc/content',
            data: {
                id,
                is_custom: isCustom,
                version: 2,
            },
        });
        const { data } = result;
        if (data?.retcode !== 0) {
            throw new Error('getTemplateInfos data', data);
        }
        return Base64.decode(data?.result?.atext[0]?.bytesText) || '';
    } catch (err) {
        console.error('getTemplateInfos catch', err);
    }
};
